import { render, staticRenderFns } from "./dr_report.vue?vue&type=template&id=04726068"
import script from "./dr_report.vue?vue&type=script&lang=js"
export * from "./dr_report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports